import { CultureCode } from '@capital-access/common/globalization';
export const FRACTION = 2;
export const MILLIONS_SYMBOL = 'mm';
export const USER_CULTURE: CultureCode = 'en-US';
export const DATE_FORMAT_SHORT = 'M/d/yyyy';
export const DATE_FORMAT_LONG = 'MMMM d, y';
export const DATE_FORMAT_FULL = 'EEEE, MMMM d, yyyy';
